import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export const PAPER_ADD_ON_FILTER_TYPES_MAP = new Map([
  ['belly-bands', CARD_TYPE_MAP.bellyBand],
  ['vellum-jackets', CARD_TYPE_MAP.vellumJacket],
  ['wax-seals', CARD_TYPE_MAP.waxSeal],
]);

export interface PaperAddOnsFilterType {
  name: string;
  search: string;
  type: string;
}

export const PAPER_ADD_ONS_FILTERS: PaperAddOnsFilterType[] = [
  {
    name: 'All',
    search: '',
    type: CARD_TYPE_MAP.paperAddOns,
  },
  {
    name: 'Belly bands',
    search: '?card_type=belly-bands',
    type: CARD_TYPE_MAP.bellyBand,
  },
  {
    name: 'Vellum jackets',
    search: '?card_type=vellum-jackets',
    type: CARD_TYPE_MAP.vellumJacket,
  },
  {
    name: 'Wax seals',
    search: '?card_type=wax-seals',
    type: CARD_TYPE_MAP.waxSeal,
  },
];
